module.exports = __webpack_public_path__ + "static/media/icon_busca.4a474c56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_busca.svg
// module id = 518
// module chunks = 0